module.exports = __webpack_public_path__ + "img/training-grey.f87444fe.png";